import { SELECT_CURRENT_ACCOUNT } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SELECT_CURRENT_ACCOUNT:
      return action.payload
    default:
      return state;
  }
}